import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
// SYSTEM1
import Loader from "@/components/widgets/loader.vue";
import Layout from "@/router/layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import { AssetMasterModule } from "@/store/modules/asset.module";
import * as _ from "lodash";
import SectionLoader from "@/components/widgets/SectionLoader.vue";
import simplebar from "simplebar-vue";
Component.registerHooks(["metaInfo"]);
let AssetCurrentReport = /** @class */ (() => {
    let AssetCurrentReport = class AssetCurrentReport extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.title = "Asset Status Report";
            this.pageIsLoading = false;
            this.isPageLoading = false;
            this.showText = true;
            this.summaryDate = null;
            this.grantTotal = 0;
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Reports",
                },
                {
                    text: "Asset Status Report",
                    active: true,
                },
            ];
        }
        get assetCurrentReport() {
            return AssetMasterModule.assetCurrentReport;
        }
        get sortedAssetCurrentReport() {
            return _.sortBy(AssetMasterModule.assetCurrentReport);
        }
        get excel() {
            return AssetMasterModule.ExportDataAssetCurrent;
        }
        GenerateAssetCurrentReportAsExcel() {
            this.isPageLoading = true;
            AssetMasterModule.GetAssetCurrentReportAsExcel().then((response) => {
                if (response) {
                    const blob = new Blob([response], {
                        type: "application/vnd.ms-excel",
                    });
                    const link = document.createElement("a");
                    link.href = window.URL.createObjectURL(blob);
                    document.body.appendChild(link);
                    link.download = `AssetStatusReport.xlsx`;
                    link.click();
                    this.isPageLoading = false;
                }
            });
        }
        created() {
            this.pageIsLoading = true;
            AssetMasterModule.GetAssetCurrentReport().then((res) => {
                if (res) {
                    this.pageIsLoading = false;
                }
            });
        }
    };
    AssetCurrentReport = __decorate([
        Component({
            name: "AssetStatusReport",
            components: {
                Loader,
                Layout,
                PageHeader,
                SectionLoader,
                simplebar,
            },
        })
    ], AssetCurrentReport);
    return AssetCurrentReport;
})();
export default AssetCurrentReport;
